<div *ngIf="horizontalMenu" class="navbar-header d-md-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <!-- <img [src]="coreConfig.app.appLogoImage" alt="brand-logo" width="36" /> -->
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>


<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="lib.toggleSidebar('menu')">
          <span [data-feather]="'menu'" class="ficon"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Bookmark -->
    <app-navbar-bookmark *ngIf="coreConfig.layout.navbar.showBookmarks"></app-navbar-bookmark>
    <!--/ Bookmark -->









    <!-- MEGA MENÜ -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="!lib.isProductionUser && !lib.isDealerUser">
      <!-- home -->
      <li class="nav-item d-block mr-1" ngbDropdown #megaMenu="ngbDropdown">
        <a class=" nav-link" placement="bottom" ngbTooltip="menu" [openDelay]="500" ngbDropdownToggle>
          <span data-feather="menu" size="28"></span>
        </a>
        <div ngbDropdownMenu class="mega-menu" aria-labelledby="megamenu" (click)="megaMenu.close();">
          <div class="row p-1">
            <div class="col-6">
              <h4 class="ml-1 font-weight-normal">Satış</h4>
              <ul class="list-group list-group-flush">
                <li *ngIf="lib?.theUser?.departments?.includes('rehau') || lib.isYonetimUser" routerLink="order/rehau" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('rehau') ? 'active' : ''">
                  <ion-icon name="cart-outline" class=" mr-1"></ion-icon>
                  <span>REHAU Siparişler</span>
                </li>
                <li *ngIf="lib?.theUser?.departments?.includes('outcustomer') || lib.isYonetimUser" routerLink="order" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('order') ? 'active' : ''">
                  <ion-icon name="cart" class=" mr-1"></ion-icon>
                  <span>DIŞ MÜŞTERİ Siparişler</span>
                </li>
                <li routerLink="account" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('account') ? 'active' : ''">
                  <ion-icon name="home-outline" class=" mr-1"></ion-icon>
                  <span>Müşteriler</span>
                </li>
              </ul>
            </div>

            <div class="col-6">
              <h4 class="ml-1 font-weight-normal">Ayarlar</h4>
              <ul class="list-group list-group-flush">
                <li *ngIf="lib.isAccountAdminUser" routerLink="/profile" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('profile') ? 'active' : ''">
                  <!-- <ion-icon name="apps-outline" class=" mr-1"></ion-icon> -->
                  <span>Profil Tanımları</span>
                </li>
                <li *ngIf="lib.isAccountAdminUser" routerLink="/foil" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('foil') ? 'active' : ''">
                  <!-- <ion-icon name="apps-outline" class=" mr-1"></ion-icon> -->
                  <span>Folyo Tanımları</span>
                </li>
              </ul>

              <h4 class="ml-1 font-weight-normal mt-2">Hareketler</h4>
              <ul class="list-group list-group-flush">
                <li *ngIf="lib.isAccountAdminUser" [routerLink]="['/act/profile']" [routerLinkActiveOptions]="{exact: true}" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('/act/profile') ? 'active' : ''">
                  <span>Profil Stok Hareketleri</span>
                </li>
                <li *ngIf="lib.isAccountAdminUser" [routerLink]="['/act/foil']" [routerLinkActiveOptions]="{exact: true}" class="list-group-item list-group-item-action border-bottom-0 cursor-pointer" [ngClass]="isActivePage('/act/foil') ? 'active' : ''">
                  <span>Folyo Stok Hareketleri</span>
                </li>
              </ul>
            </div>


          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex mx-1 border-top justify-content-between">
                <div class="d-flex">
                  <a *ngIf="lib.isAccountAdminUser" routerLink="user" class="btn btn-sm btn-icon rounded-circle" ngbTooltip="kullanıcılar" [openDelay]="500" rippleEffect [ngClass]="isActivePage('user') ? 'btn-flat-primary' : 'btn-flat'"><span data-feather="users" size="18"></span></a>
                  <!-- <a *ngIf="lib.isAccountAdminUser" routerLink="role" class="btn btn-sm btn-icon rounded-circle" ngbTooltip="güvenlik rolleri" [openDelay]="500" rippleEffect [ngClass]="isActivePage('role') ? 'btn-flat-primary' : 'btn-flat'"><span data-feather="shield" size="18"></span></a> -->
                </div>

                <a (click)="lib.logout();" class="btn btn-sm btn-icon rounded-circle float-right" ngbTooltip="oturumu kapat" [openDelay]="500"><span data-feather="power" size="18"></span></a>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>







    <!-- ORDER BUTTON -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="!lib.isProductionUser">
      <li *ngIf="lib?.theUser?.departments?.includes('rehau')" class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/order/rehau" placement="bottom" ngbTooltip="REHAU Siparişler">
          <ion-icon name="cart-outline" class="lg"></ion-icon>
        </a>
      </li>
      <li *ngIf="lib?.theUser?.departments?.includes('outcustomer')" class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/order" placement="bottom" ngbTooltip="DIŞ MÜŞTERİ Siparişler">
          <ion-icon name="cart" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

    <!-- ACCOUNT BUTTON -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="!lib.isProductionUser && !lib.isDealerUser">
      <li class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/account" placement="bottom" ngbTooltip="Müşteriler">
          <ion-icon name="home-outline" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

    <!-- PLAN BUTTON -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="!lib.isProductionUser && !lib.isDealerUser">
      <li class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/plan" placement="bottom" ngbTooltip="Planlama">
          <ion-icon name="calendar-number-outline" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

    <!-- PRODUCTION BUTTON -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="!lib.isDealerUser">
      <li class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/prod" placement="bottom" ngbTooltip="Üretim">
          <ion-icon name="build-outline" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

    <!-- REHAU FOLYO STOĞU -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="lib.isDealerUser">
      <li class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/foil" placement="bottom" ngbTooltip="Folyo Stoğu">
          <ion-icon name="bandage-outline" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

    <!-- REHAU PROFİL STOĞU -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="lib.isDealerUser">
      <li class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/profile" placement="bottom" ngbTooltip="Profil Stoğu">
          <ion-icon name="reorder-four-outline" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

    <!-- SEVKİYAT -->
    <ul class="nav navbar-nav bookmark-icons" *ngIf="!lib.isProductionUser">
      <li class="nav-item d-none d-lg-block mr-50">
        <a class="nav-link" routerLink="/send" placement="bottom" ngbTooltip="Sevkiyat">
          <ion-icon name="log-out-outline" class="lg"></ion-icon>
        </a>
      </li>
    </ul>

  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Language selection -->

    <!--/ Language selection -->

    <!-- Toggle skin  -->
    <!-- <li class="nav-item d-none d-lg-block" *ngIf="coreConfig.layout.navbar.showSkinTogeller">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin(this.userService)">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li> -->
    <!--/ Toggle skin -->

    <!-- Search -->
    <app-navbar-search *ngIf="coreConfig.layout.navbar.showSearch"></app-navbar-search>
    <!--/ Search -->

    <!-- Cart -->
    <!-- <app-navbar-cart></app-navbar-cart> -->
    <!--/ Cart -->

    <!-- Notification -->
    <app-navbar-notification *ngIf="coreConfig.layout.navbar.showNotifications"></app-navbar-notification>
    <!--/ Notification -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
        <ng-container *ngIf="lib.theUser">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bold">{{ this.lib.theUser?.fullName }}</span>
            <!-- <span class="user-status">{{ this.lib.theUser.roles }}</span> -->
            <span class="user-name font-small">{{ this.lib.theUser?.title }}</span>
          </div>
          <span class="avatar">
            <!-- <img class="round" src="assets/images/avatars/user-profile.jpg" alt="avatar" height="40" width="40" /> -->
            <img *ngIf="this.lib.theUser?.imageId" src="{{lib.imageUrl(this.lib.theUser?.imageId)}}" class="round" alt="avatar" height="40" width="40" />
            <img *ngIf="!this.lib.theUser?.imageId" src="assets/images/avatars/user-profile.jpg" class="round" alt="avatar" height="40" width="40" />
            <!-- <span class="avatar-status-online"></span> -->
          </span>
        </ng-container>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <!-- <a ngbDropdownItem [routerLink]="['/pages/profile']"><span [data-feather]="'user'" [class]="'mr-50'"></span> Profile</a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/apps/email']"><span [data-feather]="'mail'" [class]="'mr-50'"></span> Inbox</a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/apps/todo']"><span [data-feather]="'check-square'" [class]="'mr-50'"></span> Task</a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/apps/chat']"><span [data-feather]="'message-square'" [class]="'mr-50'"></span> Chats</a> -->
        <!-- <div class="dropdown-divider"></div> -->
        <!-- <a ngbDropdownItem [routerLink]="['/pages/account-settings']"><span [data-feather]="'settings'" [class]="'mr-50'"></span> Settings</a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/pages/pricing']"><span [data-feather]="'credit-card'" [class]="'mr-50'"></span> Pricing</a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/pages/faq']"><span [data-feather]="'help-circle'" [class]="'mr-50'"></span> FAQ</a> -->
        <a ngbDropdownItem (click)="lib.logout();" [routerLink]="['/auth/login']"><span [data-feather]="'power'" [class]="'mr-50'"></span> Logout</a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>